import { useState } from "react";
import { useId } from "@radix-ui/react-id";
const useMenuTrigger = (state) => {
  const menuTriggerId = useId();
  const { triggerProps, overlayProps } = useOverlayTrigger(state);
  const keyMap = {
    Escape: state.close,
    ArrowUp: state.open,
    ArrowDown: state.open,
    Enter: state.open,
    " ": state.open
  };
  return {
    menuTriggerProps: {
      ...triggerProps,
      id: menuTriggerId,
      onClick() {
        state.toggle();
      },
      onKeyDown(e) {
        const action = keyMap[e.key];
        if (e.defaultPrevented || !action) return;
        if (!state.isOpen) e.preventDefault();
        e.stopPropagation();
        action(e);
      }
    },
    menuProps: {
      ...overlayProps,
      "aria-labelledby": menuTriggerId
    }
  };
};
const useOverlayTrigger = (state) => {
  const overlayId = useId();
  const { isOpen } = state;
  return {
    triggerProps: {
      "aria-expanded": isOpen,
      "aria-controls": overlayId,
      role: "combobox"
    },
    overlayProps: {
      id: overlayId
    }
  };
};
const useMenuTriggerState = (options = {}) => {
  return useOverlayTriggerState(options);
};
const useOverlayTriggerState = ({ initialIsOpen = false }) => {
  const [isOpen, setOpen] = useState(initialIsOpen);
  return {
    isOpen,
    open() {
      setOpen(true);
    },
    close() {
      setOpen(false);
    },
    toggle() {
      setOpen(!isOpen);
    }
  };
};
export {
  useMenuTrigger,
  useMenuTriggerState
};
//# sourceMappingURL=Overlays.es.js.map
